import { Header } from "../../../components/Landing/Header/haeder.view";
import { HeaderPp } from "../../../components/Landing/Header/haederPp";
import { Footer } from "../../../components/Landing/Footer";
import '../PeopleList.scss';
import segundaDesktop from "../../../assets/pp/BANNER FORMACION.png";
import banner2 from "../../../assets/pp/Banner-resena-1-agenda.jpg"
import banner3 from "../../../assets/pp/Banner-resena-2-agenda.jpg"
import { CarouselCustom } from "../components/Carousel/CarouselCustom";
// style
import "../landing.style.scss";


export const PpFormacion = () => {
  const videos = [
    {
      id: 1,
      thumbnail: 'https://drive.google.com/file/d/1gOXOkloHTWpaTp2sXq-yT-RTTcoZ9o3N/preview',
      link: 'https://drive.google.com/file/d/1gOXOkloHTWpaTp2sXq-yT-RTTcoZ9o3N/preview',
    },
    {
      id: 2,
      thumbnail: 'https://drive.google.com/file/d/1IInQW-szwOScmaLVFsbLn9e1il0Q9EpF/preview',
      link: 'https://drive.google.com/file/d/1IInQW-szwOScmaLVFsbLn9e1il0Q9EpF/preview',
    },
  ];


  return (
    <div>
      <Header />
      <HeaderPp />
      <CarouselCustom
        images={[
          { src: segundaDesktop, alt: "Banner 1" },
          { src: banner2, alt: "Banner 2" },
          { src: banner3, alt: "Banner 3" },
        ]}
      />
      <div className="container-fluid2 pt-5" style={{ marginTop: '0' }}>
        <div className="font-family-Montserrat text-center font-color-black" style={{ fontSize: 60 }}>
          <strong>
            <h1 className="mb-5" style={{ color: '#1e3a53' }}>
              Formación artística y cultural
            </h1>
          </strong>
          <h4 className="mb-3" style={{ textAlign: 'center', marginTop: '10px' }}>
            El componente de Formación Artística impulsa la participación ciudadana y el talento local a través de 206 talleres distribuidos en diferentes territorios de la ciudad. La oferta incluye modalidades como danza, teatro, artes plásticas, fotografía, técnica vocal, entre otras, brindando a niños, jóvenes, personas adultas y mayores la oportunidad de aprender, explorar y desarrollar sus capacidades artísticas. Estos espacios promueven el acceso a procesos formativos de calidad, favorecen el encuentro comunitario, estimulan la creatividad y contribuyen a enriquecer la vida cultural en los territorios.
          </h4>
          <h4 className="mb-3" style={{ textAlign: 'center', marginTop: '10px' }}>
            En 2024, se desarrollaron 253 talleres en 16 territorios, beneficiando a más de 5.400 personas, gracias a la inversión de $7.800 millones. En el mes de marzo, iniciaron 225 nuevos talleres, que impactarán a cerca de 5.550 habitantes de las comunas y corregimientos del distrito.
          </h4>
        </div>
      </div>
      <br />
      <div className="container-fluid2 pt-5" style={{ marginTop: '0' }}>
        <div className="video-gallery">
          {videos.map((video, index) => (
            <iframe
              key={video.id}
              src={video.link}
              className="video-card highlight"
            ></iframe>
          ))}
        </div>
      </div>
      <br />
      <Footer />
    </div>
  );
};
